import { Box, Typography } from "@mui/material";
import React from "react";
import "./DevicesSpecsStyle.css";

import ZoomInMapIcon from "@mui/icons-material/ZoomInMap"; // Compact Design
import SecurityUpdateGoodIcon from "@mui/icons-material/SecurityUpdateGood"; // Mini Size
import BatteryCharging90Icon from "@mui/icons-material/BatteryCharging90"; // Internal Battery
import HandymanIcon from "@mui/icons-material/Handyman"; // Easy Installation
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"; // Easy activation
import EventRepeatIcon from "@mui/icons-material/EventRepeat"; // Scheduled Timing Report
import FenceIcon from "@mui/icons-material/Fence"; // Geo-fences

import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent"; // Multiple I/O Interfaces
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled"; // Driving Behavior Monitoring
import SpeedIcon from "@mui/icons-material/Speed"; // Speed Alarm

import SensorsIcon from "@mui/icons-material/Sensors"; // Motion Detection
import WaterIcon from "@mui/icons-material/Water"; // Water Resistant
import SosIcon from "@mui/icons-material/Sos"; // Emergency Button
import SettingsRemoteIcon from "@mui/icons-material/SettingsRemote"; // OTA Control
import PetsIcon from "@mui/icons-material/Pets"; // Use with Animal Collars
import MessageIcon from "@mui/icons-material/Message"; // Up to 10,000 Buffer Messages
import Battery1BarIcon from "@mui/icons-material/Battery1Bar"; // Low Power Alarm

import CarCrashIcon from "@mui/icons-material/CarCrash"; // Crash Detection

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import OpacityIcon from "@mui/icons-material/Opacity";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import SwapCallsIcon from "@mui/icons-material/SwapCalls";
import CachedIcon from "@mui/icons-material/Cached";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import SettingsInputAntennaIcon from "@mui/icons-material/SettingsInputAntenna";
import SimCardIcon from "@mui/icons-material/SimCard";
import EmergencyShareIcon from "@mui/icons-material/EmergencyShare";

import { Context } from "../../../components/LocalWrapper";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

function DevicesSpecs({ deviceName, deviceCategory = "vehicle" }) {
  const context = useContext(Context);
  const { t } = useTranslation();

  // Get the specs for the selected device category from the translation file
  const deviceSpecs = t(`device_categories_specs.${deviceCategory}`, {
    returnObjects: true,
  });

  const specsIcons = {
    specs_multiple_interfaces: SettingsInputComponentIcon,
    specs_driving_behavior_monitoring: DirectionsCarFilledIcon,
    specs_speed_alarm: SpeedIcon,
    specs_crash_detection: CarCrashIcon,
    specs_easy_installation: HandymanIcon,
    specs_compact_design: ZoomInMapIcon,
    specs_mini_size: SecurityUpdateGoodIcon,
    specs_internal_battery: BatteryCharging90Icon,

    specs_easy_activation: CheckCircleOutlineIcon,
    specs_motion_detection: SensorsIcon,
    specs_water_resistant: WaterIcon,
    specs_emergency_button: SosIcon,
    specs_animal_collars: PetsIcon,
    specs_buffer_messages: MessageIcon,
    specs_power_alarm: Battery1BarIcon,

    specs_real_time: AccessTimeIcon,
    specs_remote_electronic_lock: LockOpenIcon,
    specs_multiple_unlock_lock: VpnKeyIcon,
    specs_monitoring_lock_status: VisibilityIcon,
    specs_alerts_cargo_tamper: WarningAmberIcon,
    specs_waterproof_ip76: OpacityIcon,
    specs_rechargeable_battery: BatteryChargingFullIcon,

    specs_dual_communication: SimCardIcon,
    specs_auto_switch_gsm_thuraya: CachedIcon,
    specs_antenna: SettingsInputAntennaIcon,
    specs_panic_button: EmergencyShareIcon,
  };

  return (
    <Box className="specs-container">
      {Object.entries(deviceSpecs).map(([key, label]) => {
        const IconComponent = specsIcons[key];
        return (
          <Typography className="specs-item oz-btn" key={key}>
            {IconComponent && <IconComponent className="specs-icon" />}{" "}
            {/* Render the icon if it exists */}
            <span>{label}</span>{" "}
            {/* Render the label from the translation file */}
          </Typography>
        );
      })}
    </Box>
  );
}

export default DevicesSpecs;

// {deviceName != "GL300" && (
//     )}
